import { render, staticRenderFns } from "./BxbkLogin.vue?vue&type=template&id=ffea33f6&scoped=true"
import script from "./BxbkLogin.vue?vue&type=script&lang=js"
export * from "./BxbkLogin.vue?vue&type=script&lang=js"
import style0 from "./BxbkLogin.vue?vue&type=style&index=0&id=ffea33f6&prod&scoped=true&lang=css"
import style1 from "./BxbkLogin.vue?vue&type=style&index=1&id=ffea33f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffea33f6",
  null
  
)

export default component.exports